import { styled } from '@mui/material';

export const ChatContentHTML = styled('div')<{ $format: boolean }>`
  line-height: 24px;
  font-size: 16px;
  white-space: ${({ $format }) => ($format ? 'pre-line' : 'pre-wrap')};
  color: ${(props) => props.theme.palette.text.primary};
  padding-left: 0px;
  padding-top: 16px;
  word-break: break-word;

  font,
  ul {
    margin-left: 32px !important;
  }

  ol {
    margin-left: 8px;
  }

  li {
    margin-bottom: 8px;
    list-style-type: disc;
  }

  p {
    margin-bottom: 0px;
    padding-top: 8px;
  }

  b {
    color: ${(props) => props.theme.palette.text.primary};
    margin: 0px !important;
  }

  div {
    margin-left: 0px;
  }
`;
